import { render } from "./processAdmin.vue?vue&type=template&id=93168148"
import script from "./processAdmin.vue?vue&type=script&lang=js"
export * from "./processAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__